import { ChargeItem } from '@/class/model/mdm/chargeItem'
import * as ChargeMeasure from '../parameters/ChargeMeasure'
import { Message } from '@/utils/Message'
import * as RateUtil from './RateUtil'
import { Charge } from '@/class/model/act/Charge'
import * as PriceConstant from '../parameters/PriceConstant'
import $store from '@/store'
import ChargeUtils from './ChargeUtils'

/**
 * 报价单与订舱委托的自动关联
 */

export class PriceLcl2JobChargeUtil {
  constructor() {
  }

  /**
   *
   * @param job
   * @param pl PriceLcl
   * @param podCharges ArrayCollection
   * @param isColoader Boolean
   * @returns {ArrayCollection}
   */
  static async convertPrice2SellCharge(job, pl, podCharges, isColoader) {
    const charges = []
    let charge
    const chargeItem = await ChargeItem.getChargeItemByScaleCode('OF')
    if (chargeItem) {
      charge = new Charge().fillDefaultValue().getData()
      charge.chargeItemId = chargeItem.itemId // 海运费
      charge.currency = pl.currency
      let weightPrice = 0
      let volumePrice = 0
      if (isColoader) {
        weightPrice = pl.oneWeightPrice
        volumePrice = pl.oneVolumePrice
      } else {
        weightPrice = pl.twoWeightPrice
        volumePrice = pl.twoVolumePrice
      }

      const weightCalc = job.weightActual > 0 ? job.weightActual : job.weightContract
      const cubageCalc = job.cubageActual > 0 ? job.cubageActual : job.cubageContract

      if (weightPrice > volumePrice) {
        charge.measure = ChargeMeasure.WGT_CHARGE_MEASURE.code// 单位
        charge.quantity = weightCalc / 1000.0 // 数量
        charge.unitRate = weightPrice
      } else {
        charge.measure = ChargeMeasure.VOL_CHARGE_MEASURE.code
        charge.quantity = cubageCalc
        charge.unitRate = volumePrice
      }
      charge.amount = charge.quantity * charge.unitRate

      charge.taxRate = pl.sellVat
      charge.taxAmount = charge.unitRate * charge.taxRate
      this.copyDataToCharge(charge, job, true)
      charges.push(charge)

      const seaEQs = job.seaEQ
      let eqAmount = 0
      for (const seaEQ of seaEQs) {
        eqAmount += seaEQ.eqQuantity
      }

      const messages = []
      for (const pc of podCharges) {
        const chargeItem = await ChargeItem.getChargeItemByScaleCode(pc.chargeScaleCode)
        if (chargeItem) {
          const min = isColoader ? pc.coloaderMin : pc.customerRate
          const rate = isColoader ? pc.coloaderRate : pc.customerRate
          if (rate === PriceConstant.NIL || isNaN(rate)) { continue }
          charge = new Charge().fillDefaultValue().getData()
          charge.chargeItemId = chargeItem.itemId
          charge.currency = pc.currency
          charge.measure = pc.unit
          if (pc.unit === ChargeMeasure.WGT_CHARGE_MEASURE.code) {
            charge.quantity = weightCalc / 1000.0
          } else if (pc.unit === ChargeMeasure.VOL_CHARGE_MEASURE.code) {
            charge.quantity = cubageCalc
          } else if (pc.unit === ChargeMeasure.WGTX_CHARGE_MEASURE.code) {
            charge.quantity = job.chargeWeight
          } else if (pc.unit === ChargeMeasure.CNTR_CHARGE_MEASURE.code) {
            charge.quantity = eqAmount
          } else {
            charge.quantity = 1.0
          }
          charge.unitRate = rate
          charge.amount = rate * charge.quantity
          if (charge.amount < min) {
            charge.amount = min
            charge.unitRate = Number((min / charge.quantity).toFixed(2))
          }
          charge.taxRate = pc.sellVat
          charge.taxAmount = charge.unitRate * charge.taxRate
          charge.remarks = pc.remarks
          this.copyDataToCharge(charge, job, true)
          charges.push(charge)
        } else {
          messages.push(pc.chargeScaleCode)
        }
      }
    } else {
      Message.warning('费用OF未找到！')
    }
    return charges
  }

  /**
   *
   * @param charge
   * @param job
   * @param isReceivable
   */
  static async copyDataToCharge(charge, job, isReceivable) {
    charge.receivable = isReceivable
    // todo charge.job = job;
    if (!job.charges) job.charges = []
    charge.jobUuid = job.uuid
    job.charges.push(charge)
    charge.businessDate = job.businessDate
    charge.accountId = isReceivable ? job.customerId : job.bookingAgent
    charge.inputBy = $store.getters.userId
    charge.inputDate = new Date()
    charge.inputByDep = $store.getters.currentDeptId
    charge.branchId = $store.getters.currentOfficeId
    const localCurrency = RateUtil.localCurrencyByOffice()
    charge.localCurrency = localCurrency
    charge.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, charge.currency, job, charge.branchId, function(rate) {
      charge.exchangeRate = rate
    })
    // HQ币种/汇率
    charge.hqCurrency = RateUtil.getHqCurrency(charge.branchId)
    charge.hqRate = await RateUtil.getForeignExchangeRateByJob(charge.hqCurrency, localCurrency, job, charge.branchId)
    ChargeUtils.calculateTax(charge, charge.unitRate * charge.quantity, charge.taxRate)
    charge.verifiedAmount = 0
  }
}
